module.exports = __webpack_public_path__ + "img/aboutus_code.e703d3ef.png";